import React from 'react';
import createSvgIcon from '../createSvgIcon';
import { propTypes, defaultProps } from '../props';
import useColor from '../useColor';

const Instagram = ({
  color
}) => {
  const iconColor = useColor(color);
  const Icon = createSvgIcon({
    title: 'Instagram',
    width: '32px',
    height: '32px',
    viewBox: '0 0 24 24',
    content: /*#__PURE__*/React.createElement("path", {
      d: "M21.77,16.85a6.74,6.74,0,0,1-.41,2.23,3.75,3.75,0,0,1-.9,1.38,3.86,3.86,0,0,1-1.38.89,6.67,6.67,0,0,1-2.23.42c-1.26.06-1.65.07-4.85.07s-3.59,0-4.85-.07a6.67,6.67,0,0,1-2.23-.42,3.86,3.86,0,0,1-1.38-.89,3.75,3.75,0,0,1-.9-1.38,6.74,6.74,0,0,1-.41-2.23c-.06-1.26-.07-1.65-.07-4.85s0-3.58.07-4.84a6.68,6.68,0,0,1,.41-2.23,3.75,3.75,0,0,1,.9-1.38,3.75,3.75,0,0,1,1.38-.9,6.74,6.74,0,0,1,2.23-.41C8.41,2.18,8.8,2.17,12,2.17s3.59,0,4.85.07a6.74,6.74,0,0,1,2.23.41,3.75,3.75,0,0,1,1.38.9,3.75,3.75,0,0,1,.9,1.38,6.68,6.68,0,0,1,.41,2.23c.06,1.26.07,1.64.07,4.84s0,3.59-.07,4.85m2.16-9.79a9,9,0,0,0-.56-2.92A6.09,6.09,0,0,0,19.86.64,8.71,8.71,0,0,0,17,.08C15.67,0,15.26,0,12,0S8.34,0,7.06.08A8.77,8.77,0,0,0,4.14.64,6.09,6.09,0,0,0,.63,4.14,8.77,8.77,0,0,0,.07,7.06C0,8.33,0,8.74,0,12s0,3.66.07,4.94a9,9,0,0,0,.56,2.91,6.07,6.07,0,0,0,3.51,3.51,8.76,8.76,0,0,0,2.91.56c1.28,0,1.69.07,5,.07s3.67,0,4.95-.07a9,9,0,0,0,2.91-.56,6.15,6.15,0,0,0,3.51-3.51,8.71,8.71,0,0,0,.56-2.91C24,15.66,24,15.25,24,12s0-3.67-.07-4.94M12,16A4.07,4.07,0,1,1,16,12,4.07,4.07,0,0,1,12,16M12,5.72A6.26,6.26,0,1,1,5.71,12,6.25,6.25,0,0,1,12,5.72Zm6.54-1.19a1.36,1.36,0,1,1-1.37,1.36A1.36,1.36,0,0,1,18.51,4.53Z",
      fillRule: "evenodd",
      fill: iconColor
    })
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

Instagram.propTypes = { ...propTypes
};
Instagram.defaultProps = { ...defaultProps
};
export default Instagram;